"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SitesDetail = void 0;
const React = require("react");
const kpi_header_1 = require("client/components/kpi-header");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const site_kpi_1 = require("client/modules/sites/modules/sites-detail/components/site-kpi");
const store_1 = require("client/modules/sites/modules/sites-detail/store");
const store_2 = require("client/modules/users/store");
const mobx_react_1 = require("mobx-react");
const cycle_count_1 = require("./tabs/cycle-count");
const cycle_count_history_1 = require("./tabs/cycle-count-history");
const inventory_stock_1 = require("./tabs/inventory-stock");
require("./sites-detail.less");
let SitesDetail = class SitesDetail extends router_1.TabRouter {
    constructor(props) {
        super(props);
        this.withPadding = true;
        const isTmp = store_2.usersStore.user.value.user;
        // isTmp &&
        //   this.addTab(
        //     "Formulary",
        //     () => `/lots/pharmacies/${Number(this.props.params[0])}/inventory`,
        //     /^\/lots\/pharmacies\/(\d+)\/inventory$/,
        //     InventoryTab
        //   );
        store_2.usersStore.permissions.ReadLots &&
            this.addTab("Inventory", () => `/lots/pharmacies/${Number(this.props.params[0])}/inventory-lot`, /^\/lots\/pharmacies\/(\d+)\/inventory-lot$/, inventory_stock_1.InventoryStockTab);
        store_2.usersStore.permissions.ReadCycle &&
            this.addTab("Cycle Count", () => `/lots/pharmacies/${Number(this.props.params[0])}/cycle-count`, /^\/lots\/pharmacies\/(\d+)\/cycle-count$/, cycle_count_1.CycleCount);
        this.addTab("Cycle Count History", () => `/lots/pharmacies/${Number(this.props.params[0])}/cycle-count-history`, /^\/lots\/pharmacies\/(\d+)\/cycle-count-history$/, cycle_count_history_1.CycleCountHistory);
    }
    componentDidMount() {
        const siteId = Number(this.props.params[0]);
        if (siteId) {
            store_1.sitesDetailStore.readSite(siteId);
            this.showTabs(true);
        }
        else {
            this.showTabs(false);
        }
    }
    componentWillReceiveProps(props) {
        const oldSiteId = Number(this.props.params[0]);
        const newSiteId = Number(props.params[0]);
        if (newSiteId && oldSiteId !== newSiteId) {
            store_1.sitesDetailStore.readSite(newSiteId);
        }
        if (newSiteId) {
            this.showTabs(true);
        }
        else {
            this.showTabs(false);
        }
    }
    render() {
        const siteId = Number(this.props.params[0]);
        const newSiteClass = siteId === 0 ? "new-site-" : "";
        const site = store_1.sitesDetailStore.site.value;
        return (React.createElement("div", { className: "sites" },
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement("div", { className: "sites__title-wrapper--detail" },
                    React.createElement(site_kpi_1.SiteKpi, { siteKpi: {
                            name: siteId === 0
                                ? "New Pharmacy"
                                : (site &&
                                    `NCPDP: ${site.ncpdpId} | ${site.displayName ||
                                        site.name}`) ||
                                    "",
                            city: (site && site.city) || "",
                            state: (site && site.state) || "",
                            approved: 1200,
                            dispensed: 1200,
                            npi: (site && site.npiNumber) || "",
                            phone: (site && site.phone) || ""
                        } }))),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement("div", { className: `sites__${newSiteClass}tabs` }, super.render()))));
    }
};
SitesDetail = __decorate([
    mobx_react_1.observer
], SitesDetail);
exports.SitesDetail = SitesDetail;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/stocks/modules/sites-detail/sites-detail.tsx
// module id = 4095
// module chunks = 0